export default __webpack_public_path__ + "static/media/bg-mastering-complete.643707fe.svg";